<template>
  <div
    v-if="badgeData"
    class="d-flex justify-content-center mt-2 mt-lg-n2"
  >
      <template v-if="badgeData.url">
    <a
      :href="badgeData.url"
      :title="badgeData.title"
      target="_blank"
      rel="noopener noreferrer"
      @click="openInfo"
    >
      <img
        :src="badgeData.imgUrl"
        :alt="badgeData.title"
        style="max-height: 100px;"
      >
    </a>
      </template>
      <template v-else>
          <img
              :src="badgeData.imgUrl"
              :alt="badgeData.title"
              :title="badgeData.title"
              style="max-height: 100px;"
          >
      </template>
  </div>
</template>

<script>
export default {
    name: 'MhTopMerchantBadge',
    props: {
        variationProperties: {
            type: Array,
            default: () => []
        },
        merchantPropertyId: {
            type: Number,
            default: 64
        }
    },
    computed:
            {
                badgeData () {
                    const data = this.variationProperties
                        .flatMap(vp => vp.properties)
                        .find(p => p.id === this.merchantPropertyId && p.values)

                    if (!data?.values?.value) {
                        return null
                    }
                    return JSON.parse(data.values.value)
                }
            },
    methods: {
        openInfo () {
            window.open(this.badgeData.url, this.badgeData.title, 'width=850,height=800,noreferrer,noopener')
            return false
        }
    }
}
</script>
